// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as GeocodeApiModel$PorterinFeature from "../api-model/GeocodeApiModel.mjs";

function getAddressList(data) {
  return Belt_List.map(data, (function (add) {
                return {
                        short_name: add.short_name,
                        long_name: add.long_name,
                        address_types: add.types
                      };
              }));
}

function getLocation(data) {
  return {
          lat: data.lat,
          lng: data.lng
        };
}

function getGeometry(data) {
  return {
          location: getLocation(data.location)
        };
}

function apiModelToEntity(obj) {
  var place = List.hd(obj.results);
  return {
          types: place.types,
          formatted_address: place.formatted_address,
          place_id: place.place_id,
          geometry: {
            location: getLocation(place.geometry.location)
          },
          address_components: getAddressList(place.address_components)
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(GeocodeApiModel$PorterinFeature.response_decode(json), "GeocodeApiMapper.re"));
}

export {
  getAddressList ,
  getLocation ,
  getGeometry ,
  apiModelToEntity ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
